import isSameDay from 'date-fns/isSameDay';
import subDays from 'date-fns/subDays';

import { getLabelFallback } from '@utils/utils';
import { IMySavedPrescriptionItem } from '@interfaces/contactsInterfaces';
import { getDateFromGenericString, getStringFromDate } from '@utils/dateUtils';

interface Props {
    prescription: IMySavedPrescriptionItem;
}

const parseDate = (dateStr: string) =>
    getDateFromGenericString(dateStr, 'yyyy-MM-dd HH:mm:ss.SSSS');

const formatDate = (date: Date) => getStringFromDate(date, 'MM/dd/yyyy');

const isToday = (date: Date) => isSameDay(date, new Date());

const isYesterday = (date: Date) => isSameDay(date, subDays(new Date(), 1));

const isLastHour = (date: Date) => {
    const timezoneOffset = new Date().getTimezoneOffset();

    // TODO: check if this is correct
    const oneHourAgo = new Date(new Date().setMinutes(new Date().getMinutes() + timezoneOffset));
    oneHourAgo.setHours(oneHourAgo.getHours() - 1);

    return date > oneHourAgo;
};

const LastUpdate = ({ prescription: { lastUpdate, lastCreate } }: Props) => {
    const lastUpdateDate = parseDate(lastUpdate);

    if (lastUpdate === lastCreate) {
        return (
            <>
                {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_TILE_UPLOAD')}{' '}
                {formatDate(lastUpdateDate)}
            </>
        );
    }

    if (isLastHour(lastUpdateDate)) {
        return (
            <span className="green">
                {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_TILE_JUST_UPDATED')}
            </span>
        );
    }

    const lastUpdateString = isToday(lastUpdateDate)
        ? getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_TILE_TODAY')
        : isYesterday(lastUpdateDate)
        ? getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_TILE_YESTERDAY')
        : formatDate(lastUpdateDate);

    return (
        <>
            {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_TILE_UPDATE')} {lastUpdateString}
        </>
    );
};

export default LastUpdate;
